import { forwardRef } from 'react';
import Style from './SectionHeader.style';

export const SectionHeader = forwardRef(({ checked = false, dataCyName, number, children, className = '' }, ref) => {
  const containerProps = {
    className
  };

  if (dataCyName) {
    containerProps['data-cy-name'] = dataCyName;
  }

  return (
    <Style ref={ref} {...containerProps} aria-label={`${number}. ${children}`} tabIndex={-1}>
      {/*ToDo: Span austauschen mit mime_elements*/}
      <span aria-hidden="true" data-text={number} className={number ? (checked ? 'checkmark' : 'number') : ''} />
      <span aria-hidden="true" className="title">
        {children}
      </span>
    </Style>
  );
});
